const options = {
  removeItems: true,
  removeItemButton: true,
  resetScrollPosition: false,
  loadingText: ``,
  renderSelectedChoices: true,
  placeholder: true,
  placeholderValue: "Välj rättsområde",
  noResultsText: 'Inga resultat',
  noChoicesText: 'Inga alternativ',
  itemSelectText: 'Klicka för att välja',
  addItemText: (value) => {
    return `Klicka för att välja <b>“${value}”</b>`;
  },
};

export default options;
